(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[731],{

/***/ 8192:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cookie-policy",
      function () {
        return __webpack_require__(5243);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_cookie_policy; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Container/Container.js
var Container = __webpack_require__(8016);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(9630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Link/Link.js + 2 modules
var Link = __webpack_require__(8346);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/List/List.js + 1 modules
var List = __webpack_require__(5214);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItem/ListItem.js + 4 modules
var ListItem = __webpack_require__(3265);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItemText/ListItemText.js + 1 modules
var ListItemText = __webpack_require__(4548);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(2097);
;// CONCATENATED MODULE: ./src/views/pages/cookie-policy/cookie-policy-ru.tsx




const CookiesPolicyRu = ()=>{
    const theme = (0,useTheme/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        maxWidth: "md",
        sx: {
            py: 4,
            color: theme.palette.primary.contrastText,
            "& p, & ul": {
                textIndent: "2em"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h4",
                sx: {
                    mt: 0,
                    mb: 8,
                    textAlign: "center"
                },
                children: "Политика cookie"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                paragraph: true,
                children: [
                    "Настоящая Политика в отношении использования файлов cookie (далее — Политика Cookie) разработана в отношении файлов cookie, использующихся на сайте Общества с ограниченной ответственностью \xabСИЛК\xbb (далее — Компания) по адресу:",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "https://gosilk.ru",
                        target: "_blank",
                        children: "https://gosilk.ru"
                    }),
                    " ",
                    "(далее — Сайт)."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                paragraph: true,
                children: "Пользователь, принимая настоящую Политику, подтверждает ознакомление и согласие со всеми ее условиями."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                paragraph: true,
                children: "Пользователь выражает согласие на обработку информации при посещении любой из страниц Сайта."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                sx: {
                    mt: 10,
                    mb: 4,
                    textAlign: "center"
                },
                children: "Что такое файлы cookie?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                paragraph: true,
                children: "Файлы cookie — текстовые файлы, которые сохраняются на устройстве (персональном компьютере, ноутбуке, планшете, мобильном телефоне и т.п.) при посещении Сайта. Файлы cookie помогают обеспечить нормальное и безопасное функционирование Сайта. Они позволяют собирать информацию о продуктах, которыми интересуются посетители Сайта, а также учитывают использованную при посещении навигацию."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                paragraph: true,
                children: "Такие файлы идентифицируют посетителя Сайта как Пользователя, но не как личность, и, после того как будет проведена процедура анализа, удаляются из системы автоматически."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                sx: {
                    mt: 10,
                    mb: 4,
                    textAlign: "center"
                },
                children: "Виды файлов cookie"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                paragraph: true,
                children: "В зависимости от используемых Вами браузера и устройства, используются разные наборы файлов cookie, включающие в себя необходимые для бесперебойного и надежного функционирования Сайта:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* default */.Z, {
                sx: {
                    p: 0
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                        disableGutters: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                            primary: "- Технические файлы cookie. Отключение данного типа Файлов cookie может привести к ограничению Пользователя в доступе к определенным функциональным возможностям Сайта;"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                        disableGutters: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                            primary: "- Функциональные файлы cookie. Позволяют сохранять информацию о Вас, например, страну, из которой Вы посещаете Сайт, используемый язык или регион, в котором Вы находитесь. Эта информация может быть использована для предоставления Вам более подходящего опыта в соответствии с Вашим выбором. Отключение данного типа файлов cookie также может повлечь за собой ограниченное функционирование Сайта;"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                        disableGutters: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                            primary: "- Сессионные файлы cookie временные и сохраняют информацию о совершенной Пользователем активности на Сайте в течение одной сессии (т.е. до момента закрытия Сайта Пользователем);"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                        disableGutters: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                            primary: "- Аналитические файлы cookie. Данный тип файлов cookie необходим для отслеживания страниц/разделов Сайта, посещаемых Пользователем, а также выявления возможных ошибок в работе Сайта. Информация, собираемая о Пользователях данным видом Файлов cookie, является анонимной и необходима для эффективного поддержания и обновления Сайта, а также для предоставления Пользователю таргетингового контента;"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                        disableGutters: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                            primary: "- Маркетинговые файлы cookie – для измерения эффективности рекламы, анализа аудитории и развития услуг Сайта, включая эффективность рекламы, а также измерения эффективности персонализированного контента и рекламы."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                sx: {
                    mt: 10,
                    mb: 4,
                    textAlign: "center"
                },
                children: "Для чего используются файлы cookie?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                paragraph: true,
                children: "При посещении Сайта, файлы cookie могут быть использованы в следующих целях:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* default */.Z, {
                sx: {
                    pl: 0
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                        disableGutters: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                            primary: "- обеспечение функционирования и безопасности сайта;"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                        disableGutters: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                            primary: "- учет предпочтений Пользователя, получение информации о том, как Пользователь попал на Сайт;"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                        disableGutters: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                            primary: "- идентификация Пользователя (распознавание браузера и/или устройства каждый раз, когда осуществляется вход на Сайт, сохранение настроек экрана и браузера и/или сохранение логина и пароля Пользователей для входа на Сайт);"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                        disableGutters: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                            primary: "- улучшение взаимодействия Сайта и Пользователей, улучшение навигации по Сайту;"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                        disableGutters: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                            primary: "- усовершенствование оказываемых услуг, разработка новых решений для функционирования Сайта."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                sx: {
                    mt: 10,
                    mb: 4,
                    textAlign: "center"
                },
                children: "Управление файлами cookie"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                paragraph: true,
                children: "Вы можете удалить, блокировать или иным образом ограничить использование файлов cookie в настройках Вашего браузера. Для этого следуйте инструкциям на страницах справки Вашего браузера. Просим обратить внимание на то, что файлы cookie являются важной составляющей эффективной работы Сайта, поэтому удаление, блокировка или иное ограничение использования файлов cookie, может ограничить доступ Пользователя к полному функционалу Сайта."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                sx: {
                    mt: 10,
                    mb: 4,
                    textAlign: "center"
                },
                children: "Обновление Политики обработки файлов cookie"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                paragraph: true,
                children: [
                    "Это краткое описание использования Компанией файлов cookie на сегодняшний момент. Компания вправе изменить способы использования файлов cookie, в таком случае будет обновлена и настоящая Политика в отношении использования файлов cookie. При возникновении вопросов или предложений по настоящей Политике, Пользователь может обратиться с запросом по электронному адресу Компании:",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "mailto:report@gosilk.ru",
                        target: "_blank",
                        children: "report@gosilk.ru"
                    }),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var cookie_policy_ru = (CookiesPolicyRu);

;// CONCATENATED MODULE: ./src/views/pages/cookie-policy/index.tsx
// ** React Imports


// ** Source code Imports

const CookiesPolicy = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(cookie_policy_ru, {});
};
/* harmony default export */ var cookie_policy = (CookiesPolicy);

// EXTERNAL MODULE: ./src/layouts/DocsLayout.tsx
var DocsLayout = __webpack_require__(6362);
;// CONCATENATED MODULE: ./src/pages/cookie-policy/index.tsx
// ** React Imports


// ** Source code Imports


const CookiesPolicyPage = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(cookie_policy, {});
};
CookiesPolicyPage.getLayout = (page)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(DocsLayout/* default */.Z, {
        sx: {
            maxWidth: 768,
            mx: "auto"
        },
        children: page
    });
CookiesPolicyPage.acl = {
    action: "read",
    subject: "cookie-policy-page"
};
/* harmony default export */ var pages_cookie_policy = (CookiesPolicyPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [524,652,774,888,179], function() { return __webpack_exec__(8192); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);